<template>
  <h1>RepairRatioList</h1>
</template>

<script>
export default {
  name: "RepairRatioList"
};
</script>

<style></style>
